import type { Reviver } from '~/PersistentState/PersistentStateManager';
import type { StoredStateKeys } from '~/Store/actions';

export const productSearchableDataSource: Reviver<StoredStateKeys.productSearchableDataSource> = (stateObject) => {
	const searchableDataSourceState = stateObject.productSearchableDataSource;
	if (!searchableDataSourceState) {
		return null;
	}

	if (
		'datasetPresence' in searchableDataSourceState &&
		'groupedDataSources' in searchableDataSourceState &&
		'pricesPresence' in searchableDataSourceState &&
		'selectedGroupName' in searchableDataSourceState &&
		'selectedGrouppingType' in searchableDataSourceState &&
		'selectedTypes' in searchableDataSourceState
	) {
		try {
			const result = {
				...searchableDataSourceState,
				selectedTypes: searchableDataSourceState.selectedTypes
					? new Set(searchableDataSourceState.selectedTypes)
					: null,
			};

			return result;
		} catch (error) {
			console.warn('Persistent state reviving error:', error);
			return null;
		}
	}

	return null;
};
